import React from "react";
import { ClipboardList, UserCheck, Home } from "lucide-react";

const STEPS = [
  {
    n: "01",
    icon: ClipboardList,
    title: "Request & Customize",
    body: "Share your location, dates, and each child's specific needs. We build a plan tailored to your family.",
    testid: "step-request",
  },
  {
    n: "02",
    icon: UserCheck,
    title: "Match with a Professional",
    body: "We pair you with elite, background-checked caregivers whose experience matches your children's age and interests.",
    testid: "step-match",
  },
  {
    n: "03",
    icon: Home,
    title: "We Come To You",
    body: "Your caregiver arrives fully equipped with age-appropriate activities, safety essentials, and quiet-time supplies.",
    testid: "step-arrive",
  },
];

const HowItWorks = () => {
  return (
    <section
      id="how-it-works"
      data-testid="how-it-works-section"
      className="relative py-24 lg:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16">
        <div className="max-w-2xl">
          <div className="text-xs tracking-[0.25em] uppercase text-primary/80">
            How It Works
          </div>
          <h2 className="mt-4 font-serif-display text-4xl sm:text-5xl leading-[1.1] tracking-tight text-foreground">
            Three thoughtful steps.
          </h2>
          <p className="mt-5 text-muted-foreground leading-relaxed">
            From your first message to your caregiver's arrival, every detail
            is handled by our concierge team.
          </p>
        </div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-4 relative">
          {/* Connector line */}
          <div
            aria-hidden="true"
            className="hidden md:block absolute top-14 left-[16%] right-[16%] h-px bg-gradient-to-r from-transparent via-primary/40 to-transparent"
          />

          {STEPS.map(({ n, icon: Icon, title, body, testid }, i) => (
            <div
              key={n}
              data-testid={testid}
              className="relative flex flex-col items-start p-8 md:p-6 lg:p-8 bg-background rounded-2xl border border-border/60 fade-up"
              style={{ animationDelay: `${i * 150}ms` }}
            >
              <div className="flex items-center gap-4 mb-6">
                <div className="relative z-10 h-14 w-14 rounded-full bg-primary text-primary-foreground flex items-center justify-center shadow-lg shadow-primary/20">
                  <Icon size={22} />
                </div>
                <span className="font-serif-display text-3xl text-primary/30">
                  {n}
                </span>
              </div>
              <h3 className="font-serif-display text-2xl text-foreground">
                {title}
              </h3>
              <p className="mt-3 text-muted-foreground leading-relaxed">
                {body}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
